<template>
  <v-card>
    <v-img
      :src="`${publicPath}${post.src}`"
      height="300"
    >
      <v-hover>
        <template v-slot="{ hover }">
          <v-overlay
            :color="hover ? 'white' : 'black'"
            absolute
            class="align-end pa-3 justify-start"
            opacity=".2"
          >
            <v-btn
              class="ml-4"
              :href="post.category"
              color="lushary"
              dark
              small
            >
              Подробнее
            </v-btn>
          </v-overlay>
        </template>
      </v-hover>
    </v-img>

    <div class="px-3 pb-4">
      <v-card-title
        class="lushary--text headline font-weight-bold mb-2"
        :class="$vuetify.breakpoint.mdAndUp ? 'headline' : 'title'"
        v-text="post.title"
      />

      <v-card-text class="body-1 grey--text text-darken-2">
        <div
          class="font-weight-bold mb-4"
          v-text="post.date"
        />
        <p>Рекомендации по образу. Помощь в позировании.</p>
        <p>В фотосессию входят от {{ post.scorephoto }} до {{ post.scorephotoend }} фотографий в цвете и от {{ post.scoreretush }} до {{ post.scoreretushend }} фото в ретуши.</p>
        <p>Передача фотографий заказчику через Яндекс Диск.</p>
        <p>Срок получения от {{ post.dateone }} до {{ post.datetwo }} недель. Хранение в течение {{ post.week }} недель.</p>
        <p>Студия бронируется отдельно.</p>
        <p>Продолжительность: {{ post.hours }}</p>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'BlogCard',

    props: {
      post: {
        type: Object,
        default: () => ({
          category: undefined,
          date: undefined,
          blurb: undefined,
          src: undefined,
          title: undefined,
        }),
      },
    },
    data: () => ({
      show: false,
      publicPath: process.env.BASE_URL,
    }),
  }
</script>
